import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios'

import * as S from './styles';

import { Button } from '../components/Button';
import { PoweredByQITech } from '../components/PoweredByQITech';
import { useThemeContext } from "../../../../contexts/ThemeContext";
import { getOrCreateBrowserKey } from '../../../../utils/fingerprint_utils'
import { ErrorPage } from "../../../ErrorPage"
import { CardsLoading } from '../Loading'
import { resolveColor } from '../../theme/utils/resolveColor'

export const CardsConfiaPage = (props) => {
    const { clientThemeSettings } = useThemeContext();
    const { signData, setSignerStep, setSignData } = props;
    const [loadingStatus, setLoadingStatus] = useState(false);
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState({ has_error: false, status: 0 })

    const accentColor = resolveColor('text', clientThemeSettings) || '#0e3573';

    const handleNextStep = useCallback(async () => {
        let browserKey = null;
        try {
            browserKey = await getOrCreateBrowserKey();
        } catch (err) {
        }
        const payload = {
            "step": "face_recognition",
            "event_date": new Date().toISOString(),
            "image_key": "generated_by_confia",
            "device_data": {
                "device_key": browserKey
            }
        }

        const config = {
            headers:
            {
                'Authorization': signData.signer_token
            }
        }

        setLoading(true)

        axios.patch('/signer', payload, config)
            .then(response => {
                setSignerStep(response.data.next_step)
                setSignData({ ...signData, ...response.data })
            })
            .catch((error) => {
                if ([401, 403, 409].includes(error.response?.status)) {
                    setError({
                        "has_error": true,
                        "status": error.response.status
                    })
                } else {
                    setError({
                        "has_error": true,
                        "status": 500
                    })
                }
            })
            .finally(() => {
                setLoading(false)
            })
    }, [signData, setSignData, setSignerStep])

    const verifyDocumentStatus = useCallback(async () => {
        const config = {
            headers:
            {
                'Authorization': signData.signer_token
            }
        }

        axios.get('/signer/confia_status_url', config)
            .then(response => {
                if (response.data.status === 'signed')
                    handleNextStep()

                if (['blocked', 'deleted', 'refused'].includes(response.data.status))
                    setSignerStep('deactivated')
            })
    }, [signData.signer_token, handleNextStep, setSignerStep])

    useEffect(() => {
        verifyDocumentStatus();

        const interval = setInterval(verifyDocumentStatus, 3000);

        return () => clearInterval(interval);
    }, [verifyDocumentStatus]);

    const handleStartSignature = () => {
        setLoadingStatus(true);

        const currentUrl = window.location.href;
        const confiaUrl = signData?.confia_sign_url

        const finalUrl = `${confiaUrl}&urlCallback=${encodeURIComponent(currentUrl)}`;

        window.open(finalUrl, '_blank');

        setTimeout(() => setLoadingStatus(false), 2000);
    };

    if (loading) {
        return (
            <CardsLoading />
        )
    }

    if (error.has_error) {
        return (
            <ErrorPage
                error={error}
                redirectToLogin={() => setSignerStep("login")}
                resetError={() => setError({ has_error: false, status: 0 })}
                clientThemeSettings={clientThemeSettings}
            />
        )
    }

    return (
        <S.PageWrapper>
            <S.ScrollContent>
                <S.Header>
                    {clientThemeSettings?.logo_url && (
                        <S.LogoImage src={clientThemeSettings.logo_url} alt="logo" />
                    )}
                </S.Header>

                <S.HeroSection>
                    <S.Title $color={accentColor}>
                        Dupla Jornada em site de <strong>Parceiro</strong>
                    </S.Title>
                    <S.Description $color={accentColor}>
                        Complete a jornada no nosso provedor parceiro para continuar
                    </S.Description>
                </S.HeroSection>

                <S.ContentSection>
                    <S.Divider />
                    <S.Subtitle $color={accentColor}>Redirecionamento para o site da Confia</S.Subtitle>
                    <S.Paragraph>
                        Para continuar o processo de assinatura, é necessário completar a jornada no nosso provedor parceiro.
                        Ao clicar no botão você será <b>direcionado para o site da Confia</b> e deve finalizar a sua assinatura no site deles.
                    </S.Paragraph>
                    <S.Subtitle $color={accentColor}>Retorno para o QI Sign</S.Subtitle>
                    <S.Paragraph>
                        Depois de finalizar a jornada no site da Confia, você será redirecionado <b>de volta para o QI Sign automaticamente.</b>{' '}
                        Basta aguardar alguns segundos para a tela ser atualizada.
                    </S.Paragraph>
                </S.ContentSection>
            </S.ScrollContent>

            <S.FooterSection>
                <Button
                    clientThemeSettings={clientThemeSettings}
                    $loading={loadingStatus}
                    onClick={handleStartSignature}
                >
                    {loadingStatus ? 'Carregando..' : 'Realizar validação biométrica'}
                </Button>
                <PoweredByQITech />
            </S.FooterSection>
        </S.PageWrapper>
    );
}
